import React, { useEffect, useState } from 'react';
import { getHomepageSectionML } from '../../services/api';
import { useLanguage } from '../../contexts/LanguageContext';

const MESSAGES = {
  pt: 'Olá! Gostaria de saber mais sobre os serviços da Grupo BMP.',
  en: 'Hello! I would like to learn more about Grupo BMP services.',
  fr: 'Bonjour! Je voudrais en savoir plus sur les services de Grupo BMP.',
  ar: 'مرحبا! أود معرفة المزيد عن خدمات جروبو BMP.',
  zh: '您好！我想了解更多关于 Grupo BMP 服务的信息。',
};

const FloatingWhatsApp = () => {
  const { language } = useLanguage();
  const [whatsapp, setWhatsapp] = useState('');

  useEffect(() => {
    const load = async () => {
      const result = await getHomepageSectionML('contact', 'en');
      if (result.success && result.data?.whatsapp) {
        setWhatsapp(result.data.whatsapp);
      }
    };
    load();
  }, []);

  if (!whatsapp) return null;

  // Normalize: keep only digits for wa.me
  const digits = whatsapp.replace(/[^\d]/g, '');
  const lang = ['pt', 'en', 'fr', 'ar', 'zh'].includes(language) ? language : 'en';
  const message = encodeURIComponent(MESSAGES[lang] || MESSAGES.en);
  const href = `https://wa.me/${digits}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-6 right-6 z-50 group flex items-center"
    >
      {/* Tooltip */}
      <span className="hidden md:flex mr-3 bg-white text-[#2B2D42] text-sm font-semibold px-4 py-2 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
        Chat with us on WhatsApp
      </span>

      {/* Pulse ring */}
      <span className="absolute right-0 w-14 h-14 rounded-full bg-[#25D366] opacity-60 animate-ping" />

      {/* Main button */}
      <span
        className="relative w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1EBE57] shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110"
        style={{ boxShadow: '0 10px 30px rgba(37,211,102,0.45)' }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className="w-7 h-7 fill-white"
          aria-hidden="true"
        >
          <path d="M20.52 3.48A11.78 11.78 0 0 0 12.04 0C5.46 0 .1 5.36.1 11.94c0 2.1.55 4.16 1.6 5.97L0 24l6.25-1.64a11.92 11.92 0 0 0 5.79 1.47h.01c6.58 0 11.94-5.36 11.94-11.94 0-3.19-1.24-6.18-3.47-8.41ZM12.05 21.8h-.01a9.86 9.86 0 0 1-5.02-1.37l-.36-.21-3.71.97.99-3.62-.23-.37A9.85 9.85 0 0 1 2.1 11.94c0-5.48 4.46-9.94 9.95-9.94 2.66 0 5.15 1.04 7.03 2.92a9.87 9.87 0 0 1 2.91 7.02c0 5.49-4.46 9.86-9.94 9.86Zm5.45-7.39c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.48-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.49 1.07 2.89 1.22 3.09c.15.2 2.1 3.2 5.08 4.48.71.31 1.26.49 1.69.63.71.23 1.35.2 1.86.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35Z"/>
        </svg>
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
